import clsx from 'clsx';
import HubertInput from 'components/HubertUI/HubertInput';
import HubertLabel from 'components/HubertUI/HubertLabel';
import MutedText from 'components/common/MutedText';
import { ECreateQuestionMode, useQuestionEditorContext } from '../../context/create-question.context';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import {
  selectQuestionHelpText,
  selectQuestionLanguage,
  selectQuestionMode,
  selectQuestionRankingMode,
  selectQuestionType,
} from 'rtk/questionEditorSelector';
import { updateHelpText } from 'rtk/Question.Editor.Slice';
import { useInTemplateEditAndUneditable } from 'hooks/useInTemplateEditAndUneditable';
import { getHelpTextWithDefault } from './utils';
import { type TAvailableLanguageCodes } from '@hubertai/hubert-component-library';
import { useTranslation } from 'react-i18next';

const HelpTextInput = () => {
  const { t } = useTranslation('Questionsv2');
  const dispatch = useAppDispatch();
  const { questionId } = useQuestionEditorContext();
  const questionType = useAppSelector((state) => selectQuestionType(state, questionId));
  const questionHelpText = useAppSelector((state) => selectQuestionHelpText(state, questionId));
  const questionLanguage = useAppSelector((state) => selectQuestionLanguage(state, questionId));
  const mode = useAppSelector((state) => selectQuestionMode(state, questionId));
  const rankingMode = useAppSelector((state) => selectQuestionRankingMode(state, questionId));
  const inTemplateEditAndUneditable = useInTemplateEditAndUneditable(questionId, mode);
  const disabled = mode === ECreateQuestionMode.InTemplateEdit;
  const { text: helpText, isDefault } = getHelpTextWithDefault(
    questionHelpText,
    questionLanguage as TAvailableLanguageCodes,
    questionType,
    rankingMode,
  );

  return (
    <div className={clsx(inTemplateEditAndUneditable && 'hidden', 'flex flex-col justify-start gap-4', 'p-1')}>
      <div
        className={clsx(
          inTemplateEditAndUneditable && 'hidden',
          'flex flex-row justify-start gap-4',
          'hubert-vertical-center',
        )}
      >
        {/* TODO(i18n): Category 5 — ternary suffix (Default)/(Custom) embedded in label */}
        <HubertLabel htmlFor="create-question-help-text">Help Text {isDefault ? '(Default)' : '(Custom)'}</HubertLabel>
        <HubertInput
          id="create-question-help-text"
          value={helpText}
          placeholder={t('helpText.placeholder')}
          disabled={disabled}
          onChange={(e) => {
            dispatch(updateHelpText({ questionId, language: questionLanguage, value: e.target.value }));
          }}
        />
      </div>
      <div className="">
        <MutedText text={t('helpText.hint')} />
      </div>
    </div>
  );
};

export default HelpTextInput;
